"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeZoneCombobox = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const polaris_1 = require("@shopify/polaris");
const polaris_icons_1 = require("@shopify/polaris-icons");
const use_time_zone_search_hook_1 = require("@/edd/common/hooks/use-time-zone-search/use-time-zone-search.hook");
const TimeZoneCombobox = ({ error, id, label, onChange, value }) => {
    const defaultOptions = (0, react_1.useMemo)(() => [
        { label: 'America/Chicago', value: 'America/Chicago' },
        { label: 'America/Denver', value: 'America/Denver' },
        { label: 'America/Los_Angeles', value: 'America/Los_Angeles' },
        { label: 'America/New_York', value: 'America/New_York' },
        { label: 'America/Phoenix', value: 'America/Phoenix' }
    ], []);
    const [inputValue, setInputValue] = (0, react_1.useState)('');
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [options, setOptions] = (0, react_1.useState)(defaultOptions);
    const [selectedOption, setSelectedOption] = (0, react_1.useState)();
    const [searchTimeZones, { data, loading: searchLoading }] = (0, use_time_zone_search_hook_1.useTimeZoneSearch)();
    const debouncedSearchTimeZones = (0, react_1.useMemo)(() => (0, lodash_1.debounce)(searchTimeZones, 300), [searchTimeZones]);
    const updateSelection = (0, react_1.useCallback)((selected) => {
        const matchedOption = options.find((option) => {
            return option.value.match(selected);
        });
        setSelectedOption(selected);
        setInputValue((matchedOption && matchedOption.label) || '');
        // bubble up the selected value to the parent component
        onChange(selected);
    }, [options]);
    const updateText = (0, react_1.useCallback)((text) => {
        setInputValue(text);
        if (text === '') {
            setOptions(defaultOptions);
            setLoading(false);
            return;
        }
        debouncedSearchTimeZones({ variables: { q: text } });
    }, [debouncedSearchTimeZones]);
    (0, react_1.useEffect)(() => {
        // when backspacing or clearing search, the latent debounced results override the default options
        if (inputValue === '') {
            setOptions(defaultOptions);
            setLoading(false);
            return;
        }
        if (data) {
            const results = data === null || data === void 0 ? void 0 : data.timeZones.map((timeZone) => ({
                label: timeZone.name,
                value: timeZone.name
            }));
            const sortedOptions = results.sort((a, b) => {
                const collator = new Intl.Collator('en', { sensitivity: 'base' });
                return collator.compare(a.label, b.label);
            });
            setOptions((0, lodash_1.uniqBy)(sortedOptions, 'label'));
            setLoading(false);
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        setLoading(searchLoading);
    }, [searchLoading]);
    // if the current `props.value` is NOT in our default options then query for it.
    // otherwise, set the input value to the current `props.value`
    (0, react_1.useEffect)(() => {
        if (value && !defaultOptions.some((option) => option.value === value)) {
            searchTimeZones({ variables: { q: value } });
        }
        setInputValue(value);
    }, [value]);
    const optionsMarkup = options.length > 0
        ? options.map((option) => {
            return (react_1.default.createElement(polaris_1.Listbox.Option, { accessibilityLabel: option.label, key: `${option.value}`, selected: selectedOption === option.value, value: option.value }, option.label));
        })
        : null;
    const loadingMarkup = loading ? (react_1.default.createElement(polaris_1.Listbox.Loading, { accessibilityLabel: 'Loading' })) : null;
    const listboxMarkup = optionsMarkup || loadingMarkup ? (react_1.default.createElement(polaris_1.Listbox, { onSelect: updateSelection },
        optionsMarkup && !loading ? optionsMarkup : null,
        loadingMarkup)) : null;
    return (react_1.default.createElement(polaris_1.Combobox, { activator: react_1.default.createElement(polaris_1.Combobox.TextField, { autoComplete: 'off', error: error, id: id, label: label, onChange: updateText, placeholder: 'Search time zones', prefix: react_1.default.createElement(polaris_1.Icon, { source: polaris_icons_1.SearchIcon }), value: inputValue }) }, listboxMarkup));
};
exports.TimeZoneCombobox = TimeZoneCombobox;
